const main = () => {
    document.querySelectorAll('[data-version-dropdown]').forEach((wrap) => {
        const trigger = wrap.querySelector('[data-version-trigger]');
        const items = wrap.querySelectorAll('[data-version-item]');
        const label = wrap.querySelector('[data-version-label]');
        if (!trigger || !label) return;

        trigger.addEventListener('click', (e) => {
            e.stopPropagation();
            const isOpen = wrap.hasAttribute('data-open');
            closeAllVersionDropdowns();
            if (!isOpen) {
                wrap.setAttribute('data-open', '');
                trigger.setAttribute('aria-expanded', 'true');
            }
        });

        items.forEach((item) => {
            item.addEventListener('click', () => {
                items.forEach((i) => i.classList.remove('is-active'));
                item.classList.add('is-active');

                label.textContent = item.getAttribute('data-area');

                closeVersionDropdown(wrap);

                const form = document.getElementById('version-switch-form');
                if (form) {
                    form.querySelector('input[name="key"]').value = item.getAttribute('data-key') ?? '';
                    form.submit();
                }
            });
        });
    });

    document.addEventListener('click', () => {
        closeAllVersionDropdowns();
    });

    function closeVersionDropdown(wrap) {
        wrap.removeAttribute('data-open');
        const trigger = wrap.querySelector('[data-version-trigger]');
        if (trigger) trigger.setAttribute('aria-expanded', 'false');
    }

    function closeAllVersionDropdowns() {
        document.querySelectorAll('[data-version-dropdown][data-open]').forEach((w) => {
            closeVersionDropdown(w);
        });
    }
};

export default main;
